import { createSelector } from 'reselect';
import { experienceSelector } from 'selectors/testTarget/offers/fulfillmentMethodOptimizationPLP/experience/experienceSelector';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';
import { SHOW_FULFILLMENT_METHOD_OPTIMIZATION_PLP } from 'constants/TestTarget';

const showFulfillmentMethodOptimizationPLPSelector = createSelector(isTestTargetReadySelector, experienceSelector, (testReady, experience) => ({
    challengerOne: testReady && experience === SHOW_FULFILLMENT_METHOD_OPTIMIZATION_PLP.CHALLENGER_ONE,
    challengerTwo: testReady && experience === SHOW_FULFILLMENT_METHOD_OPTIMIZATION_PLP.CHALLENGER_TWO
}));

export { showFulfillmentMethodOptimizationPLPSelector };
